import React, {useEffect, useState} from 'react'
import { TableWrapper } from '../../../libs/react-mpk/wrapper'
import Modal from '../../../libs/react-mpk/components/Modal'
import t from 'counterpart'
import service from './TransaksiAktivaTetap.service'
import moment from 'moment'
import { toast } from '../../../libs/react-mpk/services'
import Utils from '../../../libs/custom/Utils'

var _baseId = "mod-table-transaksi-pajak"

const TransaksiAktivaTetapTable = ({
  className       = '',
  history,
  transaksiId
}) => {

  const [confirmDelete, setConfirmDelete] = useState(false)
  const [confirmDeleteData, setConfirmDeleteData] = useState({})

  function _closeConfirmDelete() {
    setConfirmDelete(false)
  }
  async function _submitConfirmDelete(callback) {
    var r = await service.delete(confirmDeleteData.id)
    toast.info(`Data ${confirmDeleteData.nama} telah di hapus.`); callback()
    setConfirmDelete(false)
    TableWrapper.reload(_baseId)
  }

  return (
    <>
    <TableWrapper
      baseId={_baseId}
      title={''}
      className={className}
      showCommandbar={false}
      // hintMessage={t.translate('modules.table.hint.message')}
      hintIconClassName="mdi mdi-information"
      hintMore={t.translate('modules.table.hint.more')}
      defaultData={[]}
      defaultSortBy="createdDate"
      columns={[
        {
          label: 'Akun',
          searchable: true,
          key: 'akun',
          type: TableWrapper.dataTypes.STRING,
          render: item => (item.jurnal.akun.nomor +" - "+ item.jurnal.akun.nama)
        },
        {
          label: 'Aset',
          searchable: true,
          key: 'aset',
          type: TableWrapper.dataTypes.STRING,
          render: item => <div>
            {item.transaksiAktivaTetapAsets.map((v, i)=> {
              return <p>{v.aset.nama} - {v.aset.nomor}</p>
            })}
          </div>
        },
        // {
        //   label: 'Nama Aset',
        //   searchable: true,
        //   key: 'namaAset',
        //   type: TableWrapper.dataTypes.STRING,
        //   render: item => (item.transaksiAktivaTetapAset.aset.nama)
        // },{
        //   label: 'Nomor Aset',
        //   searchable: true,
        //   key: 'nomorAset',
        //   type: TableWrapper.dataTypes.STRING,
        //   render: item => (item.transaksiAktivaTetapAset.aset.nomor)
        // },{
        //   label: 'Tanggal Perolehan',
        //   searchable: true,
        //   key: 'tanggalPerolehan',
        //   type: TableWrapper.dataTypes.STRING,
        //   render: item => (item.transaksiAktivaTetapAset.aset.tanggalPerolehan)
        // },{
        //   label: 'Harga Total Perolehan',
        //   searchable: true,
        //   key: 'hargaTotalPerolehan',
        //   type: TableWrapper.dataTypes.STRING,
        //   render: item => (Utils.numberFormat(item.transaksiAktivaTetapAset.aset.hargaTotalPerolehan))
        // }
      ]}
      actions={[
        new TableWrapper.action('Add', 'mdi mdi-plus', () => history.push(`/onpremise/transaksi-aktiva-tetap/baru/${transaksiId}`), true)
      ]}
      itemActions={[
        new TableWrapper.action('Edit', 'mdi mdi-pencil', (item) => history.push(`/onpremise/transaksi-aktiva-tetap/${item.id}/${transaksiId}`), true),
        new TableWrapper.action('Delete', 'mdi mdi-delete', (item) => { setConfirmDeleteData(item); setConfirmDelete(true)}, true)
      ]}
      onFetchData={ async query => {
        query['transaksiId.equals'] = transaksiId
        return service.get(query)
      }}
      showFilterPeriod={false}
    />
    <Modal.Confirm
      // title="Hapus Data"
      visible={confirmDelete}
      onRequestClose={_closeConfirmDelete}
      onSubmit={_submitConfirmDelete}
    >Hapus data {confirmDeleteData.nama}?</Modal.Confirm>
    </>
  )
}

export default TransaksiAktivaTetapTable
